/* eslint-disable camelcase */
import { formatNumber, getCurrencyPrecision, unformat } from '@eventbrite/intl';

export const formatAPIResponse = ({
    payout_total = '',
    cost_to_attendee = '',
    fee_breakdown = {},
    impossible_price_encountered = false,
}) => ({
    eventTotal: payout_total,
    feeBreakdown: {
        processingFee: fee_breakdown.processing_fee,
        serviceFee: fee_breakdown.service_fee,
        ticketRevenue: fee_breakdown.ticket_revenue,
        totalFees: fee_breakdown.total_fees,
        serviceFeeTax: fee_breakdown.service_fee_tax,
        processingFeeTax: fee_breakdown.processing_fee_tax,
    },
    attendeeTotal: cost_to_attendee,
    impossiblePriceEncountered: impossible_price_encountered,
});

const _stripNonDigits = (string) => string.replace(/[^0-9]/g, '');

const _preparePriceForApi = (price, currency, currencyFormat) => {
    const currencyPrecision = getCurrencyPrecision(currency);
    const formattedPrice = formatNumber(
        unformat(price, currencyFormat),
        currencyFormat,
        { precision: currencyPrecision },
    );

    return _stripNonDigits(formattedPrice);
};

export const formatDataForAPI = (state) => {
    const {
        ticketPrice,
        ticketQuantity,
        assortment,
        passOnFees,
        currency,
        currencyFormat,
    } = state;

    return {
        package: assortment,
        ticket_price: _preparePriceForApi(
            ticketPrice,
            currency,
            currencyFormat,
        ),
        ticket_quantity: ticketQuantity,
        pass_on_fees: passOnFees,
    };
};
